import { useState, useEffect, useRef } from 'react'
import { ProviderService } from '../../domain/entities/ProviderService'
import { GetProviderServicesUseCase } from '../../usecases/GetProviderServicesUseCase'
import { AxiosProviderServiceRepository } from '../../infrastructure/AxiosProviderServiceRepository'

const useCase = new GetProviderServicesUseCase(new AxiosProviderServiceRepository())

export function useProviderServices(providerId: number | null): {
  services: ProviderService[]
  loading: boolean
  error: string | null
} {
  const [services, setServices] = useState<ProviderService[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const abortRef = useRef<AbortController | null>(null)

  useEffect(() => {
    if (providerId === null) {
      setServices([])
      return
    }

    abortRef.current?.abort()
    abortRef.current = new AbortController()

    setServices([])
    setLoading(true)

    useCase.execute(providerId)
      .then((result) => {
        setServices(result)
        setLoading(false)
      })
      .catch((err: unknown) => {
        if ((err as { name?: string }).name === 'AbortError') return
        setError(err instanceof Error ? err.message : String(err))
        setLoading(false)
      })

    return () => { abortRef.current?.abort() }
  }, [providerId])

  return { services, loading, error }
}
